const constructData = (envelope, data) => {
  return {
    ...envelope,
    customAttributes: {
      ...data,
    },
  };
};

export default constructData;
